<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('configurations.reject_invoice')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div ref="selectRefAgencies">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.reject_msgs')}}</label>
              <el-form-item prop="selectedMessage">
                <base-el-select ref="messageRef" v-if="!isEmptyList" class="w-full" :options="recentMessages" v-model="form.selectedMessage" value-key="idMensaje" filterable allow-create @create-method="onCreateOptionMessage" default-first-option :disabled="isLoadingSelect" @visible-change="onExpand" @change="onChangeInput" />
                <el-input v-else class="w-full" v-model="form.selectedMessageValue" filterable :disabled="isLoadingSelect" 
                  @visible-change="onExpand" 
                  @change="onChangeInputValue" />
              </el-form-item>
              <el-form-item class="hidden">
                <el-input type="text" name="hide" value="hide" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div  class="flex-none flex items-center justify-between space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button mode="secondary-phantom-blue" type="button" :text="$t('app.cancel')" @click="toggleDialog" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" type="button" class="w-full" :text="$t('app.apply')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getRecentMessages } from '@/services/configurations/getRecentMessages'

export default
{
  name: 'reject-invoice-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        selectedMessage: null,
        selectedMessageValue: ''
      },
      recentMessages: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false,
      rules: {
        selectedMessage: [
          {
            required: true,
            message: i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('configurations.reject_msgs') }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.form.selectedMessage || !this.form.selectedMessage.mensaje || this.form.selectedMessage.mensaje === '') {
                callback(new Error(i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('configurations.reject_msgs') })))
              } else {
                callback()
              }
            }
          }
        ],
      }
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getRecentMessages({ idUsuario: this.$route.params.id, tipoMensaje: 'rechazo' })
    if (data.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
    } else {
      data.Respuesta.sort((row1, row2) => row2.fechaMensaje - row1.fechaMensaje).forEach(row => this.recentMessages.push({ label: row.mensaje, key: row.idMensaje, value: row }))
    }
    this.isLoadedData = true
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyList: function () {
      return this.recentMessages === undefined || this.recentMessages === null || this.recentMessages.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    }
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput (value = '') {
      if (typeof value === 'string' && value.trim() !== '') {
        this.onCreateOptionMessage(value.trim())
      }
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    onChangeInputValue: function (value) {
      this.form.selectedMessage = { idMensaje: -1, mensaje: value, fechaMensaje: Date.now() }
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.resetForm()
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.selectedMessage)
      this.resetForm()
    },
    onCreateOptionMessage: function (value) {
      var msg = this.recentMessages.find(x => x.label === value) || { label: value, key: -1, value: { idMensaje: -1, mensaje: value, fechaMensaje: Date.now() } }
      this.form.selectedMessage = msg
    },
    resetForm: function () {
      this.form.selectedMessage = null
      this.form.selectedMessageValue = ''
    }
  },
}
</script>

<style lang="scss" scoped></style>
